import { NavigateFunction } from 'react-router-dom';
import { Steps as ProgressSteps } from '@pages/Investment/Progress/Progress.types';

export const getPersonalDetailLockNavigation = (
  navigate: NavigateFunction,
  productId?: string
) => {
  return () =>
    navigate(`/investment-subscription/${productId}/unavailable`, {
      state: {
        progress: 6,
        type: 'personalDetailsLocked',
        nextButtonProps: {
          onClick: () =>
            navigate(`/investment-subscription/${productId}/progress`, {
              state: {
                completedSteps: [ProgressSteps.Details],
                progress: 6,
              },
              replace: true,
            }),
          disabled: false,
        },
      },
      replace: true,
    });
};
